import React from "react";

// Dependencies
import { useHistory } from "react-router-dom";

// About
const About = ({ language }) => {
  // States
  const history = useHistory();

  return (
    <React.Fragment>
      <main className="about-page">
        <section className="hero">
          <div className="container">
            <div className="about-part-one">
              <div className="about-part-one-top">
                <div className="about-part-one-top-left">
                  <a href="https://youtu.be/s0FSVXZ-wSs" target="_blank">
                    <img
                      src="../../images/pages/about/hero-img-1.webp"
                      alt=""
                    />
                  </a>
                </div>

                <div className="about-part-one-top-right">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        Hero Collection <span>//</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        히어로 컬렉션 <span>//</span>
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        英雄合集 <span>//</span>
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Bộ sưu tập anh hùng <span>//</span>
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        مجموعة البطل <span>//</span>
                      </React.Fragment>
                    ) : null}
                  </h3>
                  <p>
                    {language === "english" ? (
                      <React.Fragment>
                        The Series of Hero card IS THE FIRST NFT SET TO
                        INTEGRATE Augmented Reality within the Maxform
                        Metaverse. FOUNDED BY the BCL Core Team and COMPOSED OF
                        UNIQUE DIGITAL COLLECTIBLES ON THE ETHEREUM BLOCKCHAIN
                        ERC-721.
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        히어로 카드 시리즈는 Maxform Metaverse 내에서 증강
                        현실을 통합하기 위한 최초의 NFT 세트입니다. BCL 코어
                        팀이 설립하고 이더리움 블록체인 ERC-721의 고유한 디지털
                        수집품으로 구성됩니다.
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        Hero 卡系列是第一个在 Maxform Metaverse 中集成增强现实的
                        NFT。由 BCL 核心团队创立，由以太坊区块链 ERC-721
                        上的独特数字收藏品组成。
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Thẻ Series of Hero LÀ BỘ MỀM ĐẦU TIÊN ĐỂ TÍCH HỢP Thực
                        tế tăng cường trong Maxform Metaverse. DO Nhóm nòng cốt
                        BCL TẠO NÊN VÀ TỔ HỢP CÁC BỘ SƯU TẬP KỸ THUẬT SỐ ĐỘC ĐÁO
                        TRÊN ETHEREUM BLOCKCHAIN ​​ERC-721.
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        سلسلة بطاقات البطل هي أول NFT تم ضبطه لدمج الواقع المعزز
                        في Maxform Metaverse. أسسها الفريق الأساسي BCL ومكونة من
                        مجموعات رقمية فريدة من نوعها على EtherEum BLOCKCHAIN
                        ​​ERC-721.
                      </React.Fragment>
                    ) : null}
                  </p>
                </div>
              </div>

              <div className="about-part-one-bottom">
                <a href="https://youtu.be/8Al9l7YVLC4" target="_blank">
                  <img
                    src="../../images/pages/about/hero-img-2.webp"
                    alt=""
                  />
                </a>

                <a href="https://youtu.be/gfjBqRpmh6U" target="_blank">
                  <img
                    src="../../images/pages/about/hero-img-3.webp"
                    alt=""
                  />
                </a>
              </div>
            </div>

            <div className="about-part-two">
              <a
                href="https://youtu.be/s0FSVXZ-wSs"
                target="_blank"
                className="iframe"
              >
                <img
                  src="../../images/pages/about/hero-img-1.webp"
                  alt=""
                />
              </a>

              <div className="parts">
                <div className="left-part">
                  <img
                    src="../../images/pages/about/hero-img-4.gif"
                    alt=""
                  />
                </div>

                <div className="right-part">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        Hero is made <span>//</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        히어로는 만들어진다. <span>//</span>
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        英雄已成 <span>//</span>
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Anh hùng được tạo ra <span>//</span>
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        البطل مصنوع <span>//</span>
                      </React.Fragment>
                    ) : null}
                  </h3>
                  <p>
                    {language === "english" ? (
                      <React.Fragment>
                        In reality, Real life is dull. However, I live a new
                        life again through the avatar in the metaverse world.
                        With my passion and effort, I can be strong heros in the
                        game, and gain wealth and fame.
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        사실 현실은 최악이다. 그러나 나는 메타버스 세계에서
                        아바타를 통해 다시 새로운 삶을 살고 있다. 내 열정과
                        노력으로 나는 게임에서 강한 히어로가 될 수 있고 부와
                        명성을 얻을 수 있었습니다.
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        事实上，现实生活是乏味的。
                        然而，通过虚拟世界中的分身，我再次过上了新的生活。
                        凭借我的热情和努力，我可以成为游戏中的强者，获得财富和名声。
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Trong thực tế, cuộc sống thực là buồn tẻ. Tuy nhiên, tôi
                        lại sống một cuộc đời mới thông qua hình đại diện trong
                        thế giới metaverse. Với niềm đam mê và nỗ lực của mình,
                        tôi có thể trở thành những người hùng mạnh mẽ trong trò
                        chơi, và giành được sự giàu có và nổi tiếng.
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        في الواقع ، الحياة الحقيقية مملة. ومع ذلك ، أعيش حياة
                        جديدة مرة أخرى من خلال الصورة الرمزية في عالم metaverse.
                        بشغفي وجهدي ، يمكنني أن أكون أبطالًا أقوياء في اللعبة ،
                        وأن أكسب الثروة والشهرة.
                      </React.Fragment>
                    ) : null}
                  </p>

                  <div className="btns">
                    <button
                      className="secondary-btn"
                      onClick={() => {
                        history.push("/gallery");
                      }}
                    >
                      {language === "english" ? (
                        <React.Fragment>Go to the Gallary</React.Fragment>
                      ) : language === "korean" ? (
                        <React.Fragment>갤러리 바로가기</React.Fragment>
                      ) : language === "chinese" ? (
                        <React.Fragment>去画廊</React.Fragment>
                      ) : language === "vietnamese" ? (
                        <React.Fragment>Đi đến Gallary</React.Fragment>
                      ) : language === "arabic" ? (
                        <React.Fragment>اذهب إلى معرض الصور</React.Fragment>
                      ) : null}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-part-two">
              <a
                href="https://youtu.be/8Al9l7YVLC4"
                target="_blank"
                className="iframe"
              >
                <img
                  src="../../images/pages/about/hero-img-2.webp"
                  alt=""
                />
              </a>

              <div className="parts">
                <div className="left-part">
                  <img
                    src="../../images/pages/about/hero-img-5.gif"
                    alt=""
                  />
                </div>

                <div className="right-part">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        An avatar with a completely reversible personality{" "}
                        <span>//</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        완전히 반전된 성격의 아바타 <span>//</span>
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        An avatar with a completely reversible personality{" "}
                        <span>//</span>
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        An avatar with a completely reversible personality{" "}
                        <span>//</span>
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        An avatar with a completely reversible personality{" "}
                        <span>//</span>
                      </React.Fragment>
                    ) : null}
                  </h3>
                  <p>
                    {language === "english" ? (
                      <React.Fragment>
                        I am a female office worker, a police officer, and a
                        part-time student in the real world. <br />
                        <br /> In the metaverse world, cold assassins and heroes
                        who succeed in dungeon missions. <br />
                        <br /> We meet a different personality in the metaverse
                        world. My avatar makes my unfulfilled dreams come true.
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        나는 현실 세계의 여직원이자 경찰이자 아르바이트생이다.{" "}
                        <br />
                        <br />
                        메타버스 세계에서 던전 미션에 성공하는 냉철한 암살자들과
                        히어로들.
                        <br />
                        <br />
                        메타버스 세계에서 우리는 다른 성격을 나를 만납니다. 내
                        아바타는 내 이루지 못한 꿈을 현실로 만듭니다.
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        我是现实世界的女上班族、警察、兼职学生。
                        <br />
                        <br />{" "}
                        在metaverse世界中，冷酷的刺客和成功完成地牢任务的英雄。
                        <br />
                        <br />{" "}
                        我们在元宇宙世界遇到了不同的个性。我的头像让我未实现的梦想成真。
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Tôi là một nữ nhân viên văn phòng, một cảnh sát, và một
                        sinh viên bán thời gian ở thế giới thực.
                        <br />
                        <br /> Trong thế giới metaverse, những sát thủ lạnh lùng
                        và những anh hùng thành công trong các nhiệm vụ trong
                        ngục tối.
                        <br />
                        <br /> Chúng ta gặp gỡ một nhân cách khác trong thế giới
                        metaverse. Ảnh đại diện của tôi biến ước mơ chưa hoàn
                        thành của tôi thành hiện thực.
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        أنا عاملة مكتب وضابطة شرطة وطالبة بدوام جزئي في العالم
                        الحقيقي.
                        <br />
                        <br /> في عالم metaverse ، القتلة الباردون والأبطال
                        الذين ينجحون في مهمات الأبراج المحصنة.
                        <br />
                        <br /> نلتقي بشخصية مختلفة في عالم ميتافيرس. الصورة
                        الرمزية الخاصة بي تجعل أحلامي التي لم تتحقق.
                      </React.Fragment>
                    ) : null}
                  </p>

                  <div className="btns">
                    <button
                      className="secondary-btn"
                      onClick={() => {
                        history.push("/gallery");
                      }}
                    >
                      {language === "english" ? (
                        <React.Fragment>Go to the Gallary</React.Fragment>
                      ) : language === "korean" ? (
                        <React.Fragment>갤러리 바로가기</React.Fragment>
                      ) : language === "chinese" ? (
                        <React.Fragment>去画廊</React.Fragment>
                      ) : language === "vietnamese" ? (
                        <React.Fragment>Đi đến Gallary</React.Fragment>
                      ) : language === "arabic" ? (
                        <React.Fragment>اذهب إلى معرض الصور</React.Fragment>
                      ) : null}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="about-part-two">
              <a
                href="https://youtu.be/gfjBqRpmh6U"
                target="_blank"
                className="iframe"
              >
                <img
                  src="../../images/pages/about/hero-img-3.webp"
                  alt=""
                />
              </a>

              <div className="parts">
                <div className="left-part">
                  <img
                    src="../../images/pages/about/hero-img-6.gif"
                    alt=""
                  />
                </div>

                <div className="right-part">
                  <h3>
                    {language === "english" ? (
                      <React.Fragment>
                        Who is the winner <span>//</span>
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        누가 승자인가? <span>//</span>
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        谁是赢家？<span>//</span>
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Ai là người chiến thắng? <span>//</span>
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        من هو الفائز؟ <span>//</span>
                      </React.Fragment>
                    ) : null}
                  </h3>
                  <p>
                    {language === "english" ? (
                      <React.Fragment>
                        There are people with numerous personalities and faces
                        in the real world. <br />
                        <br /> They have a variety of occupations and
                        personalities. There are many heroes in the metaverse
                        world, and each of them has different weapons and
                        abilities. <br />
                        <br /> An avatar that replaces you is born as a hero
                        with new personalities, weapons and abilities.
                      </React.Fragment>
                    ) : language === "korean" ? (
                      <React.Fragment>
                        현실 세계에는 수많은 성격과 얼굴을 가진 사람들이
                        있습니다. <br />
                        <br /> 그들은 다양한 직업과 성격을 가지고 있습니다.
                        메타버스 세계에는 많은 히어로들이 있으며, 각각의 무기와
                        능력이 다릅니다. <br /> 당신을 대신할 아바타는 새로운
                        성격, 무기, 능력을 지닌 히어로로 태어납니다.
                      </React.Fragment>
                    ) : language === "chinese" ? (
                      <React.Fragment>
                        现实世界中有许多个性和面孔的人。
                        <br />
                        <br />
                        他们有各种各样的职业和个性。元界世界中有许多英雄，每个人都有不同的武器和能力。
                        <br />
                        <br />
                        一个取代你的化身作为英雄出生，拥有新的个性、武器和能力。
                      </React.Fragment>
                    ) : language === "vietnamese" ? (
                      <React.Fragment>
                        Có những người với vô số tính cách và khuôn mặt trong
                        thế giới thực. <br />
                        <br /> Họ có nhiều nghề nghiệp và tính cách khác nhau.
                        Có rất nhiều anh hùng trong thế giới metaverse, và mỗi
                        người trong số họ có vũ khí và khả năng khác nhau.{" "}
                        <br />
                        <br />
                        Hình đại diện thay thế bạn được sinh ra như một anh hùng
                        với tính cách, vũ khí và khả năng mới.
                      </React.Fragment>
                    ) : language === "arabic" ? (
                      <React.Fragment>
                        هناك أشخاص لديهم العديد من الشخصيات والوجوه في العالم
                        الحقيقي.
                        <br />
                        <br /> لديهم مجموعة متنوعة من المهن والشخصيات. هناك
                        العديد من الأبطال في عالم metaverse ، ولكل منهم أسلحة
                        وقدرات مختلفة.
                        <br />
                        <br /> ولدت الصورة الرمزية التي تحل محلك كبطل بشخصيات
                        وأسلحة وقدرات جديدة.
                      </React.Fragment>
                    ) : null}
                  </p>

                  <div className="btns">
                    <button
                      className="secondary-btn"
                      onClick={() => {
                        history.push("/gallery");
                      }}
                    >
                      {language === "english" ? (
                        <React.Fragment>Go to the Gallary</React.Fragment>
                      ) : language === "korean" ? (
                        <React.Fragment>갤러리 바로가기</React.Fragment>
                      ) : language === "chinese" ? (
                        <React.Fragment>去画廊</React.Fragment>
                      ) : language === "vietnamese" ? (
                        <React.Fragment>Đi đến Gallary</React.Fragment>
                      ) : language === "arabic" ? (
                        <React.Fragment>اذهب إلى معرض الصور</React.Fragment>
                      ) : null}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <img
          src="../../images/body-bg-img-2.png"
          alt=""
          className="body-bg-img-1"
        />
      </main>
    </React.Fragment>
  );
};

// Export
export default About;
